export const POST_VIDEO_MODAL_WIDTH = 720;

export const UPLOAD_CARD_WIDTH = 135;
export const UPLOAD_CARD_HEIGHT = 180;

export const LIBRARY_CARD_WIDTH = 156;
export const LIBRARY_CARD_HEIGHT = 270;
export const LIBRARY_GRID_WIDTH = 672;
export const LIBRARY_PAGE_SIZE = 20;
export const GENERATED_CARD_HEIGHT = 270;
export const UPLOADED_CARD_HEIGHT = 210;
export const GENERATED_COVER_HEIGHT = 214;
export const UPLOADED_CARD_MEDIA_HEIGHT = 210;

export const MAX_VIDEO_FILE_BYTES = 100 * 1024 * 1024;

export const VIDEO_FILE_ACCEPT = [".mp4", ".mov", "video/mp4", "video/quicktime"] as const;

export type PostVideoSourceTab = "library" | "videoFile";
export type PostVideoLibrarySubTab = "generated" | "uploaded";
